import {OFFLINE_STORES,getOfflineStorageDriver} from './offlineStorageAdapter.js';
import {canonicalMerge,mergeHash} from './visitaMergeJournal.js';

export async function archiveVisitaOperationReceipt({original,receipt,empresaId,isCurrent,driver=getOfflineStorageDriver()}) {
    if(!isCurrent()||receipt.applied_operation_uuid!==original.operation_uuid
        ||receipt.empresa_id!=null&&Number(receipt.empresa_id)!==Number(empresaId)
        ||receipt.visita_id!=null&&Number(receipt.visita_id)!==Number(original.visitaId))throw Error('El comprobante no corresponde a la operación enviada.');
    const id=`operation-receipt:${empresaId}:${original.userId}:${original.operation_uuid}`;
    const bodyHash=await mergeHash(canonicalMerge(original.payload));
    const previous=await driver.get(OFFLINE_STORES.CONTEXTS,id);
    if(previous){
        if(previous.bodyHash!==bodyHash||previous.userId!==original.userId||previous.empresaId!==empresaId||previous.visitaId!==original.visitaId)throw Error('La operación conserva otro original.');
        return previous;
    }
    const row={id,kind:'operation_receipt',userId:original.userId,empresaId,visitaId:original.visitaId,scope:`operation:${empresaId}:${original.userId}`,
        templateVersion:'operation-receipt-v1',version:crypto.randomUUID(),bodyHash,original:structuredClone(original),receipt:structuredClone(receipt)};
    if(driver.publishVisitaContext)await driver.publishVisitaContext(row,'');
    else await driver.mutate(OFFLINE_STORES.CONTEXTS,id,current=>current||row);
    if(!isCurrent()||canonicalMerge(await driver.get(OFFLINE_STORES.CONTEXTS,id))!==canonicalMerge(row))throw Error('No se confirmó la conservación del original y su comprobante.');
    return row;
}
